import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import { StarReview } from 'components/reviewV2/StarReview';
import './reviewChartBarV2.scss';

export default function ReviewChartBar({ rating, percentRating, reviewCount }) {
	return (
		<div className="review-chart-bar-v2">
			<div className="stars-block">
				<StarReview
					outOf={5}
					rating={rating}
					starSize="smaller"
					showOutOf={false}
					showLabel={false}
				/>

				<Text weight="standard" color="gray" size="smaller" className="review-count">{reviewCount}</Text>
			</div>
			<div className="bar-container">
				<div
					className="bar"
					style={{ width: `${percentRating}%` }}
				/>
			</div>
		</div>
	);
}

ReviewChartBar.propTypes = {
	/** What rating this is - i.e. 5 star, 4 star, etc */
	rating: PropTypes.number.isRequired,
	/** Percentage to show the bar at */
	percentRating: PropTypes.number.isRequired,
	/** How many reviews there are for the rating */
	reviewCount: PropTypes.number.isRequired
};
